import {useTranslation} from '@aboutyou/i18n';
import {useHistory, useWishlistRoute} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';
import {GenericIconName} from '@aboutyou/ui-components';
import {
  useWishlistContainsCampaignItems,
  useWishlistCount,
} from '@aboutyou/user';
import React, {useMemo} from 'react';
import {useSelectedDiscountColor} from '../../Campaigns/SelectedDiscounts/useSelectedDiscountColor';
import {IconMetaNavigationItem} from './IconMetaNavigationItem';

export const IconMetaNavigationItemWishlist: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({onClick}) => {
  const wishlistContainsSaleItems = useWishlistContainsCampaignItems();
  const {t} = useTranslation();
  const wishlistCount = useWishlistCount().count;
  const selectedDiscountColor = useSelectedDiscountColor();
  const trackFeature = useTrackFeature();
  const wishlistRoute = useWishlistRoute();
  const history = useHistory();

  const wishlistSaleIndication = useMemo(() => {
    return selectedDiscountColor && wishlistContainsSaleItems
      ? {color: selectedDiscountColor}
      : undefined;
  }, [selectedDiscountColor, wishlistContainsSaleItems]);

  return (
    <IconMetaNavigationItem
      dataTestId="Wishlist"
      icon={GenericIconName.NavHeaderWishlist}
      label={t('Wishlist')}
      count={wishlistCount}
      badgeOffset={{
        right: 0,
        top: 2,
      }}
      saleIndication={wishlistSaleIndication}
      onClick={event => {
        onClick(event);
        trackFeature({eventType: 'click', label: 'wishlist_icon'});
        history.push(wishlistRoute);
      }}
    />
  );
};
